const isResponseOk = (response: PromiseSettledResult<any>): response is PromiseFulfilledResult<any> => {
  return response.status === 'fulfilled' &&
    response.value !== undefined &&
    !response.value.error
};

export {
  isResponseOk
}